module.exports = __webpack_public_path__ + "static/tower-ac29d164db5fe82ff7edc99fbaabd73a.jpg";